import { Navigation } from "./Navigation";
import { useAuth } from "../../hooks/useAuth";
import { Login } from "../../pages/Login";
import { useEffect, useState } from "react";
import { WorldClockWidget } from "../widgets/WorldClockWidget";
import { MyCampaignsWidget } from "../widgets/MyCampaignsWidget";
import { IncomingChallengeToast } from "../games/IncomingChallengeToast";
import { IncomingTransferPopup } from "../aiCaller/IncomingTransferPopup";

export function Layout({ children }) {
    const { isAuthenticated, checkedAuth } = useAuth();
    const [sidebarWidth, setSidebarWidth] = useState(() => {
        return localStorage.getItem("sidebarCollapsed") === "true" ? 64 : 256;
    });

    useEffect(() => {
        const updateWidth = () => {
            const collapsed = localStorage.getItem("sidebarCollapsed") === "true";
            setSidebarWidth(collapsed ? 64 : 256);
        };

        window.addEventListener("storage", updateWidth);
        window.addEventListener("sidebarToggle", updateWidth);
        
        updateWidth();

        return () => {
            window.removeEventListener("storage", updateWidth);
            window.removeEventListener("sidebarToggle", updateWidth);
        };
    }, []);

    if (!checkedAuth) return <></>;
    if (!isAuthenticated) {
        return <Login />;
    }

    return (
        <div className="crm-shell">
            {/* Top header bar */}
            <header className="crm-topbar" style={{ paddingLeft: `${sidebarWidth}px` }}>
                <div className="crm-topbar-inner">
                    <div />
                    {/* Space for breadcrumbs or page title if needed */}
                </div>
            </header>
            {/* Red accent stripe */}
            <div className="crm-accent-stripe" style={{ marginLeft: `${sidebarWidth}px` }} />

            <Navigation />

            {/* Main content */}
            <main 
                className="crm-main"
                style={{ marginLeft: `${sidebarWidth}px` }}
            >
                {children}
            </main>

            {/* Floating world clock — draggable, persistent position */}
            <WorldClockWidget />

            {/* Floating "my campaigns" self-service panel — only renders for a
                user who is the assigned transfer agent on a campaign */}
            <MyCampaignsWidget />

            {/* Floating challenge invites (works on any page) */}
            <IncomingChallengeToast />

            {/* AI transfer screen-pop (works on any page) */}
            <IncomingTransferPopup />
        </div>
    );
}
